<template id="list-media">    
    <div>
        <!-- List cms -->
        <div class="listCmsTag">
            <div class="row">
                <div class="col-md-4">
                    <h3>User</h3>
                </div>
                <div class="col-md-4">
                    <general-searchbox @searchButtonClick="setCurrentKeywordandSearch"></general-searchbox>
                </div>
                <div class="col-md-4">
                    <a v-bind:href="formUrl" class="btn btn-success float-right mr-3">เพิ่ม</a>
                </div>
            </div>            
            <general-pagination v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data" @paginateItemClick="setCurrentPageAndSearch"></general-pagination>            
            <general-loading v-if="showLoading"></general-loading>
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-body mt-1" v-for="item in items" v-bind:key="item.id">
                        <div class="row">
                            <div class="col-md-9">
                                <h4 class="text">
                                    <span>{{item.name}}</span> <span class="text text-secondary">{{item.email}}</span>
                                </h4>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group float-right">
                                    <a class="btn btn-light" v-bind:href="base_item_url+'/form/'+item.id">แก้ไข</a>
                                    <!-- <button type="button" class="btn btn-info" data-toggle="modal" data-target="#ConfirmDuplicateModal" @click="setForDuplicateItemId(item.id)">ทำซ้ำ</button> -->
                                    <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#ConfirmDeleteModal" @click="setForDeleteItemId(item.id)">ลบ</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <span>สร้างเมื่อ {{item.created_at_x.time_ago}}, แก้ไขเมื่อ {{item.updated_at_x.time_ago}}</span>
                            </div>
                            <!-- <div class="col-md-1">
                                <span class="badge badge-danger ml-1" v-if="item.disabled==1">ปิดการใช้งาน</span>
                                <span class="badge badge-success ml-1" v-if="item.disabled==0">เปิดให้ใช้งาน</span>
                            </div> -->
                            <div v-if="item.role" class="col-md-8">                                  
                                <span class="badge badge-primary ml-1">{{item.role.title}}</span>
                                <span v-for="permission in item.role.permission" v-bind:key="'permission_'+permission.id" class="badge badge-secondary ml-1">{{permission.title}}</span>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <general-pagination v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data" @paginateItemClick="setCurrentPageAndSearch"></general-pagination>
            <div v-if="recordNotFound" class="alert alert-warning" role="alert">
                ไม่พบข้อมูล
            </div>
        </div>        
        <!-- delete modal    -->
        <general-delete-modal @ConFirmDeleteClick="performDeleteItem"></general-delete-modal>
        <!-- <confirmDuplicateModal @ConFirmDuplicateClick="performDuplicateItem"></confirmDuplicateModal> -->
        <!-- alert modal    -->
        <button style="display:none" type="button" class="btn btn-primary" data-toggle="modal" data-target="#AlertModal" ref="decoyAlertModalClick">test</button>
        <general-alert-modal :alertMessage="alertMessage"></general-alert-modal>
    </div>
</template>

<script>
    // import confirmDuplicateModal from './confirmDuplicateModal'
    // Vue.component('generalDuplicateModal', require('./confirmDuplicateModal.vue').default);
    export default {
        components:{
            // confirmDuplicateModal,
        },
        data() {
            return {
                items:[],
                item:{},
                item_id:'',
                paginate_data:{
                    _infos:{},
                    _base_item_list_url:''
                },
                alertMessage:{
                    titleClassName:'warning',
                    titleMessage:'แจ้งเตือน!!',
                    bodyClassName:'warning',
                    bodyMessage:'This is alert',
                },
                edit:false,
                recordNotFound:false,                
                showLoading:true,
                formUrl:'/user/form',
                base_item_url:'/user',
                currentSearchKeyword:'',
                currentPage:1,
                currentPerpage:23,
            }
        },
        mounted() {
            //console.log('Component mounted.')            
        },
        created(){
            // this.fetchCmses();
            this.searchItems();
            // this.paginate_data._base_item_list_url = this.base_item_list_url;
        },
        methods:{       
            setCurrentKeywordandSearch(searchKeyword){
                this.currentPage = 1;
                this.currentSearchKeyword = searchKeyword;
                this.searchItems();
            },
            setCurrentPageAndSearch(page){
                this.currentPage = page;
                this.searchItems();
            },
            searchItems(){      
                let url = this.base_item_url+'/list';
                url = url+'?page='+this.currentPage;
                url = url+'&perpage='+this.currentPerpage;
                url = url+'&name='+this.currentSearchKeyword;
                this.fetchItems(url);
            },
            fetchItems(url){
                this.showLoading = true;
                this.items = [];
                url = url || this.base_item_url+'/list';
                axios.get(url).then(response => {                    
                    this.items = response.data.items;                    
                    this.paginate_data._infos = response.data._infos._paginate;               
                    this.paginate_data._infos._url_range = this.computePaginate(this.paginate_data._infos._last_page);                    
                    this.recordNotFound = this.items.length == 0 ? true : false;
                    this.showLoading = false;
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },
            computePaginate(lastpage){
                let result = []; let i=0;
                let data = Object.entries(this.paginate_data._infos._url_range);
                // console.log(this.paginate_data._infos._last_page);
                data.forEach(function(item){
                    if( item[0] > 0 && item[0] <= lastpage ){
                        result[i] = item;
                        i++;                       
                    }                    
                });
                // console.log(result);
                return result;
            },
            setForDeleteItemId(item_id){
                // console.log(item_id);
                this.item_id_for_delete = item_id;
            },
            performDeleteItem(){
                // console.log(this.item_id_for_delete);
                axios.post(this.base_item_url+'/'+this.item_id_for_delete+'/delete').then(response => {                          
                    // console.log(response.data._infos)
                    this.searchItems();
                })
                .catch(errors => {                    
                    if(errors.response.data._infos.result){                        
                        this.alertMessage.bodyMessage = errors.response.data._infos.result;
                        this.$refs.decoyAlertModalClick.click();
                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถลบได้ '+ errors.response.data);
                    }                    
                })
                ;
            },            
        },        
    }
</script>